import React from "react";
import { Text } from "@dxp-feed/ui/Text";
import { HighlightText } from "./HighlightText";
import { toTitleCase } from "@/helpers/global";

const QuickLinksList = ({
  title,
  items,
  searchedKeyword,
  onItemClick,
  onRemoveItem,
  loading = false,
  noItemsText,
}: {
  title?: string;
  items: { id: string; label: string }[];
  searchedKeyword: string;
  onItemClick: (label: string) => void;
  onRemoveItem?: (id: string) => void;
  loading?: boolean;
  noItemsText?: string;
}) => {
  let content;

  if (loading) {
    content = (
      <Text
        as="p"
        className="text-body break-all break-words text-[#313131] cursor-pointer mb-10"
      >
        Finding the best <Text className="inline-block"  as="span" >
       matches for you...</Text>
      </Text>
    );
  } else if (items.length < 1 && noItemsText) {
    content = (
      <Text as="h2" className="text-body break-all break-words text-[#313131]">
        {noItemsText}
      </Text>
    );
  } else {
    content = (
      <ul className="mb-[16px] last:!mb-[4px]">
        {items.map((item) => {
          const formattedLabel =
            item.label.length < 45
              ? toTitleCase(item.label)
              : `${toTitleCase(item.label.substring(0, 45))}...`;

          return (
            <li key={item.id} className="pb-[8px] flex justify-between gap-2">
              <Text
                as="h2"
                className="text-body text-[#313131] cursor-pointer line-clamp-2"
                style={{ wordBreak: "break-word" }}
                onClick={() => onItemClick(item.label)}
              >
                <HighlightText
                  text={formattedLabel}
                  query={searchedKeyword.trim()}
                />
              </Text>
              {onRemoveItem && (
                <Text
                  onClick={() => onRemoveItem(item.id)}
                  className="cursor-pointer text-base"
                >
                  &times;
                </Text>
              )}
            </li>
          );
        })}
      </ul>
    );
  }

  return (
    <>
      <Text as="h2" className="text-base font-bold pb-[8px]">
        {title}
      </Text>
      {content}
    </>
  );
};

export default QuickLinksList;
